export default "__VITE_ASSET__BeFC$o9a__"